<template>
	<section
		class="flex flex-col px-content py-20 relative will-change"
		:data-scroll-section="inner == 'false'"
	>
		<div class="grid grid-cols-1 xl:grid-cols-3 gap-5 xl:gap-6">
			<div
				class="card-activity mb-6"
				v-show="posts"
				v-for="(post, index) in posts"
				:key="index"
			>
				<a :href="post.link" class="h-full flex flex-col">
					<div
						class="overflow-hidden relative mb-6 after:block after:bg-black after:opacity-20 after:absolute after:w-full after:h-full after:z-[8] after:top-0 after:left-0 hover:after:opacity-50 after:transition-opacity"
					>
						<img
							class="object-cover w-full h-full"
							v-if="post.data.fields.image"
							:src="post.data.fields.image.sizes.customslide"
							:alt="post.data.fields.image.alt"
						/>
					</div>
					<div
						class="card-toponyms__txt pb-[18px] pt-6 px-0 flex flex-col justify-between"
					>
						<div>
							<span
								class="block text-sm leading-[1.42] text-navy-blue-02 mb-3"
								v-show="post.date"
								v-html="formatDate(post.date)"
							></span>
							<h3
								class="text-2xl tracking-[1px] mb-5"
								v-show="post.title.rendered"
								v-html="post.title.rendered"
							></h3>
						</div>
						<div>
							<p class="text-md mb-3" v-if="post.content">
								{{ getFirstLines(post.content.rendered) }}
							</p>
							<span
								class="text-xs tracking-little text-navy-blue-03 font-bold uppercase mt-auto"
								v-show="post.link"
								>{{ __("SEE MORE", "ccave") }}</span
							>
						</div>
					</div>
				</a>
			</div>
		</div>

		<a
			class="btn justify-center mt-12 xl:mt-20 mx-auto md:w-[384px]"
			:href="nextPageUrl"
			v-show="hasMore"
			@click.prevent="loadMore()"
			:aria-label="__('Load more posts', 'ccave')"
			rel="next"
			>{{ loading ? __("LOADING...", "ccave") : __("LOAD MORE", "ccave") }}</a
		>
	</section>
</template>

<script>
import { format, parse } from "date-fns";
export default {
	name: "NewsBlogList",
	data: function () {
		return {
			posts: [],
			loading: false,
			perPage: 9, // @POP, STAVI NA 9 KADA SREDIS READ MORE GUMB
			page: 1,
			hasMore: false,
		};
	},
	computed: {
		nextPageUrl() {
			const base = window.location.pathname
				.replace(/\/page\/\d+\/?$/, "")
				.replace(/\/$/, "");
			return `${base}/page/${this.page + 1}/`;
		},
	},
	mounted() {
		const wpPagination = document.querySelector("#news-blog-ssr");
		if (wpPagination) wpPagination.style.display = "none";
		const match = window.location.pathname.match(/\/page\/(\d+)\//);
		const urlPage = match ? parseInt(match[1]) : 1;
		this.page = urlPage;
		this.getPosts();
	},
	methods: {
		getPosts(append = false) {
			const searchParams = new URLSearchParams({
				per_page: this.perPage,
				page: this.page,
			});

			this.loading = true;
			this.$http
				.get(this.endpoints.rest_base_endpoint + "wp/v2/posts?" + searchParams)
				.then((res) => {
					if (!res.data || res.data.length === 0) {
						window.location.href = "/404";
						return;
					}
					if (append) {
						this.posts = this.posts.concat(res.data);
					} else {
						this.posts = res.data;
					}

					const totalPages = parseInt(res.headers["x-wp-totalpages"]);
					this.hasMore = this.page < totalPages;
				})
				.finally(() => (this.loading = false));
		},
		loadMore() {
			if (this.loading) return;
			this.page += 1;

			const base = window.location.pathname
				.replace(/\/page\/\d+\/?$/, "")
				.replace(/\/$/, "");
			history.pushState({ page: this.page }, "", `${base}/page/${this.page}/`);

			this.getPosts(true);
		},
		formatDate(date) {
			let parsed = parse(date, "yyyy-MM-dd'T'HH:mm:ss", new Date());
			let formated = format(parsed, "dd MMM yyyy");
			return formated;
		},
		getFirstLines(content) {
			if (!content) return "";
			const temp = document.createElement("div");
			temp.innerHTML = content;

			let shortenConent = temp.textContent || temp.innerText || "";
			return shortenConent.slice(0, 180) + " ...";
		},
	},
};
</script>
